import Styled from 'styled-components';

const checkIcon: (color: string) => string = color => {
  const encodedColor: string = encodeURIComponent(color);

// tslint:disable-next-line:max-line-length
  return `"data:image/svg+xml;charset=utf8,%3Csvg width='20' height='15' viewBox='0 0 20 15' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3EShape%3C/title%3E%3Cpath d='M0 7.143L2.143 5l5 3.57L17.857 0 20 1.43 7.143 15' fill='${encodedColor}' fill-rule='evenodd'/%3E%3C/svg%3E"`;
};

export const ListCheckElement = Styled.li`
  font-size: 1.7rem;
  line-height: 1.4;
  margin-bottom: 1em;
  padding-left: 2em;
  text-align: left;
  background-image: url(${({ theme }) => checkIcon(theme.brand.colorPrimary)});
  background-repeat: no-repeat;
  background-position: 0 3px;
`;

ListCheckElement.displayName = 'ListCheckElement';
